import { useSelector } from 'react-redux';

export function userHasRole(user: any, role: string): boolean {
    if (!user) return false;
    const roles: string[] | undefined =
        user.additional?.roles || user.roles;
    return Array.isArray(roles) && roles.includes(role);
}

/**
 * Returns true if the current backend user has the named role. Firebase's
 * user object is retained as a fallback for older callers, but `/auth` is the
 * source of truth for application roles.
 */
export function useHasRole(role: string): boolean {
    return useSelector((state: any) => {
        const user = state?.app?.backendUser || state?.app?.user;
        return userHasRole(user, role);
    });
}

export default useHasRole;
